/* RPNT · ajustes
   Con la bolsa abierta, el tabulador no se sale de la ventana y, al cerrarla,
   el foco vuelve al boton que la abrio. */
(function () {
  'use strict';
  var opener = null;
  function cajon() { return document.querySelector('[data-cajon]'); }
  function abierta() { var c = cajon(); return !!c && c.getAttribute('data-abierto') === 'true'; }
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('[data-abrir-bolsa],[data-anadir]');
    if (t) opener = t;
  }, true);
  var estabaAbierta = false;
  setInterval(function () {
    var ahora = abierta();
    if (estabaAbierta && !ahora && opener && document.contains(opener)) {
      try { opener.focus({ preventScroll: true }); } catch (err) {}
      opener = null;
    }
    estabaAbierta = ahora;
  }, 250);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !abierta()) return;
    var panel = cajon().querySelector('.cajon__panel'); if (!panel) return;
    var focos = Array.prototype.slice.call(panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'))
      .filter(function (el) { return el.offsetParent !== null; });
    if (!focos.length) return;
    var primero = focos[0], ultimo = focos[focos.length - 1];
    if (!panel.contains(document.activeElement)) { e.preventDefault(); primero.focus(); return; }
    if (e.shiftKey && document.activeElement === primero) { e.preventDefault(); ultimo.focus(); }
    else if (!e.shiftKey && document.activeElement === ultimo) { e.preventDefault(); primero.focus(); }
  });
})();

/* Opciones con un solo valor (p. ej. "Color: Black" que crea Tapstitch): se marcan solas y se ocultan,
   porque el tono ya se muestra arriba y el cliente solo debe elegir la talla. */
(function () {
  'use strict';
  function preparar() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-fcp-grupo]'), function (g) {
      var ins = g.querySelectorAll('input[data-fcp-valor]');
      if (ins.length !== 1) return;
      g.hidden = true;
      if (!ins[0].checked) {
        ins[0].checked = true;
        ins[0].dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', preparar);
  else preparar();
})();

/* Producto con la opcion Color (negro y blanco en el mismo producto): los puntos de arriba
   muestran cada color y, al tocarlos, eligen ese color (las fotos cambian solas). */
(function () {
  'use strict';
  var TONOS = ['black', 'white', 'negro', 'blanco', 'bone', 'hueso'];
  function preparar() {
    var cont = document.querySelector('.fcp__tonos'); if (!cont) return;
    var grupo = null;
    Array.prototype.forEach.call(document.querySelectorAll('[data-fcp-grupo]'), function (g) {
      var ins = Array.prototype.slice.call(g.querySelectorAll('input[data-fcp-valor]'));
      if (!grupo && ins.length > 1 && ins.every(function (i) { return TONOS.indexOf(i.value.toLowerCase()) > -1; })) grupo = g;
    });
    if (!grupo) return;
    var ins = Array.prototype.slice.call(grupo.querySelectorAll('input[data-fcp-valor]'));
    cont.innerHTML = '';
    var botones = ins.map(function (i) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'fcp__tono';
      b.setAttribute('data-color', i.value.toLowerCase());
      b.setAttribute('aria-label', i.value);
      b.style.cssText = 'padding:0;border:0;background:none;cursor:pointer';
      b.appendChild(document.createElement('span'));
      b.addEventListener('click', function () {
        i.checked = true; i.dispatchEvent(new Event('change', { bubbles: true })); marcar();
      });
      cont.appendChild(b);
      return b;
    });
    function marcar() { ins.forEach(function (i, k) { botones[k].classList.toggle('es-actual', i.checked); }); }
    grupo.addEventListener('change', marcar);
    marcar();
    setTimeout(marcar, 0);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', preparar);
  else preparar();
})();
